/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";


export default function Logo3DGeometry(props) {
  const { nodes, materials } = useGLTF("/logo-3d.glb");
  return (
    nodes["rect254-3"].geometry
  );
}

useGLTF.preload("/logo-3d.glb");
